import React from 'react';
import ReactDOM from 'react-dom';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import { Desktop, LargeMobile } from 'Responsive';
import ExpenseInputs from './components/ExpenseInputs';
import AssetsInputs from './components/AssetsInputs';
import CostsInputs from './components/CostsInputs';
import TotalView from './components/TotalView';
import ResultsView from './components/ResultsView';

export default class StartupCalculator extends React.Component {
  static init(id, props) {
    ReactDOM.render(
      <StartupCalculator {...props} />,
      document.getElementById(id),
    );
  }

  static formatCurrency(value) {
    return String(value).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  constructor() {
    super();
    this.state = {
      expenses: ['0', '0', '0', '0', '0', '0', '0'],
      assets: ['0', '0', '0', '0'],
      costs: ['0', '0', '0', '0', '0'],
      tabIndex: 0,
    };
    this.updateExpenses = this.updateExpenses.bind(this);
    this.updateAssets = this.updateAssets.bind(this);
    this.updateCosts = this.updateCosts.bind(this);
    this.toExpensesTab = this.setTabIndex.bind(this, 0);
    this.toAssetsTab = this.setTabIndex.bind(this, 1);
    this.toCostsTab = this.setTabIndex.bind(this, 2);
    this.toTotalTab = this.setTabIndex.bind(this, 3);
  }

  setTabIndex(tabIndex) {
    this.setState({
      tabIndex,
    });
  }

  updateExpenses(value, index) {
    const { expenses } = this.state;
    expenses[index] = value;
    this.setState({
      expenses,
    });
  }

  updateAssets(value, index) {
    const { assets } = this.state;
    assets[index] = value;
    this.setState({
      assets,
    });
  }

  updateCosts(value, index) {
    const { costs } = this.state;
    costs[index] = value;
    this.setState({
      costs,
    });
  }

  render() {
    const { costs, assets, expenses } = this.state;
    // toFixed converts to a string so we use urnary + to convert to number
    let costSum = +costs.reduce((a, b) => parseFloat(a) + parseFloat(b), '0').toFixed(2);
    let assetSum = +assets.reduce((a, b) => parseFloat(a) + parseFloat(b), '0').toFixed(2);
    let expenseSum = +expenses.reduce((a, b) => parseFloat(a) + parseFloat(b), '0').toFixed(2);
    let total = +(costSum + assetSum + expenseSum).toFixed(2);
    total = StartupCalculator.formatCurrency(total);
    costSum = StartupCalculator.formatCurrency(costSum);
    assetSum = StartupCalculator.formatCurrency(assetSum);
    expenseSum = StartupCalculator.formatCurrency(expenseSum);

    return (
      <div className="container startup-calculator-container">
        <div className="row row-eq-height startup-calculator-equal-cols">
          <div className="col-md-4 col-md-offset-1">
            <h1>Startup Costs Calculator</h1>
          </div>
          <div className="col-md-6">
            <p className="startup-calculator-subtitle">
              {'We created a calculator that you can use to determine how much money you will need to keep your business running considering your initial costs before you begin to turn a profit. This total is based on the sum of your startup expenses, assets and recurring monthly costs.'}
            </p>
          </div>
        </div>
        <div className="row row-eq-height startup-calculator-equal-cols">
          <div className="col-xs-12 col-md-10 col-md-offset-1">
            <Tabs
              selectedIndex={this.state.tabIndex}
              onSelect={tabIndex => this.setState({ tabIndex })}
            >
              <TabList>
                <Tab>Expenses</Tab>
                <Tab>Assets</Tab>
                <Tab>Recurring Costs</Tab>
                <LargeMobile>
                  <Tab>Total Costs</Tab>
                </LargeMobile>
              </TabList>
              <TabPanel>
                <p className="startup-calculator-pane-title">{'Startup expenses are one time costs that occur before you open for business. These expenses are intangible.'}</p>
                <ExpenseInputs
                  onChange={this.updateExpenses}
                  values={expenses}
                  sum={expenseSum}
                  next={this.toAssetsTab}
                />
              </TabPanel>
              <TabPanel>
                <p className="startup-calculator-pane-title">{'Assets are tangible things or intangible expenses that you own (like intellectual property). Assets are not deductible like startup expenses.'}</p>
                <AssetsInputs
                  onChange={this.updateAssets}
                  values={assets}
                  sum={assetSum}
                  back={this.toExpensesTab}
                  next={this.toCostsTab}
                />
              </TabPanel>
              <TabPanel>
                <p className="startup-calculator-pane-title">{'The costs you pay to cover the monthly expenses associated with starting a business.'}</p>
                <CostsInputs
                  onChange={this.updateCosts}
                  values={costs}
                  sum={costSum}
                  back={this.toAssetsTab}
                  next={this.toTotalTab}
                />
              </TabPanel>
              <LargeMobile>
                <TabPanel className="startup-calculator-total-pane react-tabs__tab-panel">
                  <TotalView
                    title="Total Expenses"
                    sum={expenseSum}
                  />
                  <TotalView
                    title="Total Assets"
                    sum={assetSum}
                  />
                  <TotalView
                    title="Total Recurring Costs"
                    sum={costSum}
                  />
                  <TotalView
                    title="Total"
                    sum={total}
                  />
                </TabPanel>
              </LargeMobile>
            </Tabs>
          </div>
          <Desktop>
            <ResultsView
              expenseSum={expenseSum}
              assetSum={assetSum}
              costSum={costSum}
              total={total}
            />
          </Desktop>
        </div>
      </div>
    );
  }
}




// WEBPACK FOOTER //
// ./src-react/StartupCalculator/index.jsx